import { onLoad, onReady } from "@gr-exports/async/dom";
import { tracking } from "@gr-exports/async/tracking";
import { defineEvent } from "@gr-exports/async/nexus";
import { lockInit, triggerGlobalInitIfReleased, unlockInit } from "./init/defer.js";
import { initPdpWorkaround, isPdpWorkaroundEnabled } from "./special/pdpWorkaround.js";
import { initDataTracker } from "./init/init.js";

/*                                                                   */
/*                                                           */
onReady.subscribe(initDataTracker);

/*                                                               */
/*                                                                   */
/*                                                                */

/*                                                                           */
if (isPdpWorkaroundEnabled()) {
  /*                                            */
  /*                                    */
  initPdpWorkaround(triggerGlobalInitIfReleased);
} else {
  /*                                                              */
  onLoad.subscribe(triggerGlobalInitIfReleased);
}

export default tracking.assignNamespace(
  {
    lockInit,
    unlockInit,
    onInit: defineEvent(),
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
